import React, { useState, useEffect } from 'react';
import { /*makeStyles,*/ Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/Error';
import _get from 'lodash/get';

const AfitdSnackbar = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [open, setOpen] = useState(false);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { autoHideDuration = 3000, message, ...otherProps } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    const successMessage = _get(message, 'successMessage');
    const errorMessage = _get(message, 'errorMessage');
    const alertMessage = successMessage || errorMessage;
    const snackbarOpen = open && !!alertMessage;
    const severity = !!errorMessage ? 'error' : 'success';
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    useEffect(() => {
        if (message || errorMessage) {
            setOpen(true);
        }
    }, [message, errorMessage]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <Snackbar autoHideDuration={autoHideDuration} open={snackbarOpen} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} {...otherProps}>
            <Alert variant="filled" severity={severity} iconMapping={{ success: <CheckCircleOutlineIcon fontSize="inherit" />, error: <ErrorIcon fontSize="inherit" /> }}>
                {alertMessage}
            </Alert>
        </Snackbar>
    );
    //---------------------------------------------------------------------
};

export default AfitdSnackbar;
